interface IParticipant {
  id?: string;
  activityOccurrenceId?: string;
  activityRegistrationId?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  allergies?: string;
  reducedMobility: boolean;
  memberNumber?: string;
}

export class Participant implements IParticipant {
  id?: string;
  activityOccurrenceId?: string;
  activityRegistrationId?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  allergies?: string;
  reducedMobility = false;
  memberNumber?: string;
}